import { Flex, Spinner, Text } from '@chakra-ui/react'

import { Size } from '../types/types'

export const FloorPlanPlaceholder = ({
  fetching,
  imageSize,
  imageUrl,
}: {
  fetching?: boolean
  imageSize?: Size
  imageUrl?: string
}) => {
  // if fetching or loading an image
  if (fetching || (!fetching && imageUrl && !imageSize)) {
    return (
      <Flex
        alignItems='center'
        height='100%'
        justifyContent='center'
        pos='absolute'
        width='100%'
      >
        <Spinner alignSelf='center' size='lg' />
      </Flex>
    )
  }

  if (!fetching && !imageUrl) {
    return (
      <Flex
        alignItems='center'
        height='100%'
        justifyContent='center'
        pos='relative'
        width='100%'
      >
        <Text>There is no floor plan for the selected floor</Text>
      </Flex>
    )
  }

  return null
}
